import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ shape, custom, palette }: Theme) => ({
  contentWrapper: {
    borderRadius: shape.borderRadius,
    backgroundColor: palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '25px 0',
    margin: '20px 0',
  },
  imgWrapper: {
    height: 160,
    margin: '0 auto',
  },
  img: {
    height: 160,
  },
  textField: {
    margin: '20px 0px',
    width: 200,
    fontSize: 24,
    '&>label': {
      transform: 'translate(14px, 20px) scale(1)',
    },
  },
  textInfo: {
    fontSize: 14,
    color: custom.grey[3],
    marginBottom: 10,
    textAlign: 'center',
  },
  textAction: {
    fontSize: 14,
    color: custom.grey[3],
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  disable: {
    pointerEvents: 'none',
    color: custom.grey[10],
  },
  submitButton: {
    fontSize: 16,
    lineHeight: 1.25,
    padding: '12.5px',
  },
  input: {
    fontSize: 24,
    padding: 20,
  },
  errorAlert: {
    marginTop: 30,
  },
}));
